import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Button,
  Dialog,
  Typography,
  colors,
  InputBase,
  IconButton,
  Divider,
  useMediaQuery
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SendIcon from '@material-ui/icons/Send';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

const modules = {
  toolbar: [
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }, { align: [] }],
    [{ color: [] }, { background: [] }],
    ['link', 'image'],
    ['clean']
  ]
};

const formats = [
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'align',
  'color',
  'background',
  'link',
  'image'
];

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: 500
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(1, 0)
  },
  actions: {
    backgroundColor: colors.grey[100],
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end'
  },
  startButton: {
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  },
  inputPadding: {
    padding: theme.spacing(0, 1)
  },
  quillContainer: {
    display: 'flex',
    flexGrow: 1
  },
  quill: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    '& .ql-toolbar.ql-snow': {
      border: 'none',
      borderBottom: '1px solid #eee',
      paddingTop: 0
    },
    '& .ql-container.ql-snow': {
      border: 'none',
      borderBottom: '1px solid #eee',
      flexGrow: 1
    }
  }
}));

const PricingModal = props => {
  const { open, onClose, onSendMailStudents, selected, className } = props;

  const theme = useTheme();
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [subject, setSubject] = useState('');
  const [htmlBody, setHtmlBody] = useState('');

  const rteChange = (content, delta, source, editor) => {
    setHtmlBody(editor.getHTML());
  };

  const handleClose = () => {
    onClose();
    setHtmlBody('');
    setSubject('');
  }

  const students = selected.map(item => item.email)

  return (
    <Dialog
      classes={{ paper: clsx(classes.root, className) }}
      fullScreen={fullScreen}
      maxWidth="sm"
      onClose={onClose}
      open={open}
    >
      <div className={classes.header}>
        <Typography
          variant="h3"
        >
          New Message
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <InputBase
        className={classes.inputPadding}
        fullWidth
        placeholder="To"
        value={students.join('; ') + ';'}
      />
      <Divider className={classes.divider} />
      <InputBase
        autoFocus
        className={classes.inputPadding}
        fullWidth
        onChange={({ target }) => setSubject(target.value)}
        placeholder="Subject"
        value={subject}
      />
      <Divider className={classes.divider} />
      <div 
        className={classes.quillContainer}
        data-text-editor="name"
      >
        <ReactQuill
          bounds="[data-text-editor='name']"
          className={classes.quill}
          formats={formats}
          modules={modules}
          onChange={rteChange}
          placeholder="Leave a message"
          theme="snow"
          value={htmlBody || ''}
        />
      </div>
      <div className={classes.actions}>
        <Button
          color="primary"
          disabled={!subject.length}
          endIcon={<SendIcon />}
          onClick={() => onSendMailStudents({ students, subject, htmlBody }, handleClose)}
          variant="contained"
        >
          Send
        </Button>
      </div>
    </Dialog>
  );
};

PricingModal.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onSendMailStudents: PropTypes.func,
  open: PropTypes.bool,
  selected: PropTypes.array,
};

export default PricingModal;
